<div>
	<div class="modal-header">
		<h4 class="modal-title">Relancer le dossier {{folderName}}</h4>
		<button type="button" class="close" aria-label="Close" (click)="cancelDialog()"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body">
		<p>Etes-vous sûre de vouloir relancer le projet ?</p>
        <p>Pour démarrer le projet, cliquez sur le bouton "Relancer".</p>
        <p>Pour annuler l'action, cliquez sur le bouton "Annuler".</p>
		<form [formGroup]="folderRestartForm">
			<div class="form-group">
				<input type="checkbox" formControlName="emailSendControl" id="mail-send"/>
				&nbsp;
				<label class="ls-label-strong" for="mail-send">Envoyer un mail aux utilisateurs</label>
			</div>
        </form>
    </div>

    <div class="modal-footer">
		<button type="button" class="btn btn-light" (click)="cancelDialog()">Annuler</button>
		<button type="submit" class="btn btn-primary" [disabled]="!enableAction || !folderRestartForm.valid" (click)="save()">{{buttonText}}</button>
	</div>
</div>